module.exports = "<div class=\"container\">\r\n  <div class=\"row\">\r\n    <app-header></app-header>\r\n  </div>\r\n  <div class=\"row content-container\" *ngIf=\"!isRouting\">\r\n    <breadcrumb></breadcrumb>\r\n    <router-outlet *ngIf=\"loggedIn\"></router-outlet>\r\n    <app-spinner *ngIf=\"!loggedIn\" text=\"Initialising, please wait...\"></app-spinner>\r\n  </div>\r\n  <app-spinner *ngIf=\"isRouting\" text=\"Loading...\"></app-spinner>\r\n  <div class=\"row\">\r\n    <app-footer></app-footer>\r\n  </div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main